import script from "./JpReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./JpReview.vue?vue&type=script&setup=true&lang=ts"

import "./JpReview.vue?vue&type=style&index=0&id=38644b12&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38644b12"]])

export default __exports__